import { Box } from "@chakra-ui/react";
import { ButtonProps } from "src/components/base/button";
import { WfPopover } from "src/components/base/wf-popover";
import { TagButton } from "./tag-button";
import { ITag } from "./tag.types";

export const Tag = ({ label, tooltip, tooltipRaw, color, isCrossedOut, urlIdentifier, isSearchable, ...buttonProps }: ITag & ButtonProps) => {
    const tt = typeof tooltip === "string" ? tooltipRaw : tooltip;

    const renderButton = () => (
        <TagButton colorScheme={color} {...buttonProps}>
            <Box {...(isCrossedOut ? { textDecorationLine: "line-through", textDecorationThickness: "2px" } : {})}>{label}</Box>
        </TagButton>
    );

    if (!tt) {
        return renderButton();
    }

    return <WfPopover {...tt}>{renderButton()}</WfPopover>;
};
